const env = (envName) => {
    const runtime = typeof window !== 'undefined' ? window.__ENV__ : undefined;
    let value = runtime?.[envName];

    // CRA `npm start`: webpack підставляє process.env. У production-бандлі ця гілка вирізається.
    if (value === undefined && process.env.NODE_ENV !== 'production') {
        value = process.env[envName];
    }

    if (value === undefined) {
        console.warn(`⚠️ Env variable "${envName}" is not defined`);
    }
    return value;
};


export default env;
